import { configureStore, createSlice } from '@reduxjs/toolkit';
import enrollmentReducer from '@/store/slices/enrollmentSlice';

const appSlice = createSlice({
  name: 'app',
  initialState: { initialized: true },
  reducers: {},
});

export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    enrollment: enrollmentReducer,
  },
});